
const providerBackdrop        = require('./provider-backdrop')
const providerConfirmation    = require('./provider-confirmation')
const providerDialog          = require('./provider-dialog')
const providerDt              = require('./provider-dt')
const providerFullcont        = require('./provider-fullcont')
const providerMenu            = require('./provider-menu')
const providerPage            = require('./provider-page')
const providerSnack           = require('./provider-snack')
const providerReport          = require('./provider-report')
const providerQuickform       = require('./provider-quickform')
const providerQuickview       = require('./provider-quickview')
const providerChat            = require('./provider-chat')
const providerMultitable      = require('./provider-fullcont-multitable')

export function start(detail){  
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      backdrop:        { start: (detail)=>{  providerBackdrop.start(detail)         }},
      confirmation:    { start: (detail)=>{  providerConfirmation.start(detail)     }},
      dialog:          { start: (detail)=>{  providerDialog.start(detail)           }},
      dt:              { start: (detail)=>{  providerDt. start(detail)              }},
      fullcont:        { start: (detail)=>{  providerFullcont. start(detail)        }},
      menu:            { start: (detail)=>{  providerMenu.start(detail)             }},
      multitable:      { start: (detail)=>{  providerMultitable.start(detail)       }},
      page:            { start: (detail)=>{  providerPage.start(detail)             }},
      snack:           { start: (detail)=>{  providerSnack.start(detail)            }},
      report:          { start: (detail)=>{  providerReport.start(detail)           }},
      quickform:       { start: (detail)=>{  providerQuickform.start(detail)        }},
      quickview:       { start: (detail)=>{  providerQuickview.start(detail)        }},
      chat:            { start: (detail)=>{  providerChat.start(detail)             }},
}
